import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { TTheme } from './typings'
import { buildTheme } from './utils/buildTheme'

const [ThemeProviderRaw, useTheme] = createContext<TTheme>(`Theme`)

type TProps = RequiredChildren & FirstParam<typeof buildTheme>

/**
 * basic Theme provider using react context
 *
 * if you use some styling package (styled-components, emotion, Chakra)
 * you will probably need to create another provider using that package,
 * use `buildTheme` util to replicate the theme merging logic
 */
export const ThemeProvider: React.FC<TProps> = ({ children, ...themeColors }) => {
  const theme = buildTheme(themeColors)

  return <ThemeProviderRaw value={theme}>{children}</ThemeProviderRaw>
}

// the raw provider is exported for convenience when building custom providers
export { useTheme, ThemeProviderRaw }
